:host {
  display: block;
  --border-color: var(--sl-divider-border-color, #dcdcdc);
  --border-style: var(--sl-divider-border-style, dashed);
  --border-width: var(--sl-divider-border-width, 1px);
  --margin: var(--sl-divider-margin, 0);
  --border: var(--sl-border-style, var(--border-width) var(--border-style) var(--border-color));
}

.sportsline-divider {
  border-top: var(--border);
  border-bottom: none;
  margin: var(--margin);
}